import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { Spin, Space } from 'antd';
import GET_SIGNUP_V2_IMPRESSIONS from '../../../../GraphQl/Queries/GET_SIGNUP_V2_IMPRESSIONS';
import Controller from './SignupImpressionsController';

const SignupImpressionsLoader = ({ children, signupId }) => {
  const { loading, data } = useQuery(GET_SIGNUP_V2_IMPRESSIONS, {
    fetchPolicy: 'cache-first',
    variables: {
      signupId,
    },
  });

  if (loading) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <Spin spinning={true} />
      </div>
    );
  }

  const impressionsData = data?.campaignOrderSignupsWithEvents;

  return <Controller impressionsData={impressionsData}>{children}</Controller>;
};

export default SignupImpressionsLoader;
